import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import FindBooking from "@/pages/FindBooking";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBookingDetail from "@/pages/AdminBookingDetail";
import EventGallery from "@/pages/EventGallery";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/find-booking" element={<FindBooking />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/bookings/:bookingId" element={<AdminBookingDetail />} />
            <Route path="/gallery/:galleryId" element={<EventGallery />} />
          </Routes>
          <Toaster
            theme="dark"
            position="top-center"
            toastOptions={{
              style: {
                background: "#121212",
                border: "1px solid rgba(212,175,55,0.3)",
                color: "#fff",
                borderRadius: "0",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
